import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

//Global registration of base components
Vue.config.productionTip = false
const requireComponent = require.context(  
  './components',  
  false,  
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Получение конфигурации компонента
  const componentConfig = requireComponent(fileName)

  const componentName = fileName.split('/').pop()?.replace(/\.\w+$/, '')
  if(typeof componentName !== 'undefined')
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})
  

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
